import { Component, OnInit } from '@angular/core';
import {NgbModal, NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-filter-user-dialog',
  templateUrl: './filter-user-dialog.component.html',
  styleUrls: ['./filter-user-dialog.component.scss']
})
export class FilterUserDialogComponent implements OnInit {

  criterioBusqueda:string="";
  tipoBusqueda="7";

  constructor(
    public activeModal: NgbActiveModal
  ) { 
    
  }

  ngOnInit() {
  }

  cancelSearch(){

    this.activeModal.close('close');


  }
  filtrar(){
    if(this.tipoBusqueda == '7' || this.tipoBusqueda == '8') {
      this.filtrarUsuarios();
    } else {
      if(this.criterioBusqueda !== "") {
        this.filtrarUsuarios();
       }
    }
    
  }

  filtrarUsuarios() {
    let data={
      criterio:this.criterioBusqueda,
      tipo:this.tipoBusqueda
    }
    this.activeModal.close(data); 
  }

  h(x) {
    // console.log(x);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/filter-user-dialog/filter-user-dialog.component.ts